import React, { useEffect, useState } from "react";
import { COLOR } from "../../../Config/Color";
import NewLeaveRequest from "./Component/NewLeaveRequest";
import NewWfhRequest from "./Component/NewWfhRequest";
import MainLayout from "../../../../layouts/MainLayout";
import Loader from "../../../../components/Loader";
import { useSelector } from "react-redux";

const NewLeaveRequestPage = () => {
  const [activeTab, setActiveTab] = useState("Leave Request");
  const tabs = ["Leave Request", "WFH Request"];
  const isDataLoading = useSelector((state) => state?.adminData?.loading);

  return (
    <MainLayout>
      <div className="page-wrapper">
        {/* {
          isDataLoading &&
          <Loader style={{ height: "100" }} />
        } */}
        <div className="content">
          <div className="newattendance-container">
            <div className="w-100">
              <h1 className="my-2 text-start fs-24 text-dark">
                Employee Leave/ WFH requests
              </h1>
            </div>
            <div className="flex items-center justify-between border-b border-gray-300 px-10 pt-1 bg-white rounded-lg shadow-sm mt-5">
              {/* Tabs */}
              <div className="d-flex gap-3 py-2">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}

                    className={` font-medium  pb-3 bold ${activeTab === tab
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-[#78829D]" // Custom color for inactive tab
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ marginTop: "20px", width: "100%" }}>
              {activeTab === "Leave Request" && <NewLeaveRequest />}
              {activeTab === "WFH Request" && <NewWfhRequest />}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NewLeaveRequestPage;
